import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const bsfzNavigationsService = {
  get(reportId) {
    return fetch(`/api/claim_project_reports/${reportId}/bsfz_navigations`, request.get);
  }
};
export default bsfzNavigationsService;